module.exports = __webpack_public_path__ + "img/broadcast-test-icon2.d9093a65.png";